import { clsx } from "clsx";
import { type CSSProperties, type PropsWithChildren, type ReactNode, useEffect, useState } from "react";

import { Collapse } from "../Collapse/Collapse.tsx";
import { HStack } from "../Stack/HStack.tsx";
import { Spacer } from "../Stack/Spacer.tsx";
import { TriggerButtonSize } from "../TriggerButton/settings.ts";
import { TriggerButton } from "../TriggerButton/TriggerButton.tsx";
import cssStyle from "./Disclosure.module.css";

export interface DisclosureProps {
  defaultOpen?: boolean;
  header?: ReactNode;
  actions?: ReactNode[];
  className?: string;
  style?: CSSProperties;
}

export const Disclosure = ({
  defaultOpen,
  header,
  actions,
  children,
  className,
  style,
}: PropsWithChildren<DisclosureProps>) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  const hasLeft = !!header;

  if (!hasLeft && !actions) return null;

  return (
    <>
      <HStack className={className} style={{ outline: "none", ...style }}>
        <TriggerButton
          icon={isOpen ? "keyboard_arrow_down" : "keyboard_arrow_right"}
          onPress={() => {
            setIsOpen(!isOpen);
          }}
          label=""
          aria-label={isOpen ? "Collapse" : "Expand"}
          size={TriggerButtonSize.Mini}
        />
        {header}
        <Spacer />
        <div className={clsx(cssStyle.actions)} data-testid={"header-bar-actions"}>
          {actions}
        </div>
      </HStack>
      <Collapse isExpanded={isOpen} style={{ paddingLeft: "20px" }}>
        {children}
      </Collapse>
    </>
  );
};
